import Api from 'services/api'
import BaseModel from './BaseModel'
import _ from 'underscore'
import { Trend } from 'types/DeviceMetric'

export const defaultTrend: Trend = {
  name: '',
  metricList: [],
  groupList: [],
  alertList: [],
  draft: true,
  waterMark: '',
  plotZero: true,
  drawLines: true,
  hideChart: false,
  hideRanges: false,
  showAlert: true,
  showZeroWaterMark: false,
  id: undefined,
  sortPosition: 0
}
class TrendModel extends BaseModel {
  constructor (options = defaultTrend) {
    super(options || defaultTrend)
    Object.seal(this)
  }

  save (trend, saveMethod, onSaveSuccessCallback, onSaveFailCallback, onValidationErrorCallback) {
    const errors = { ...this.validate(trend) }
    if (_.isEmpty(errors)) {
      return Api.DeviceMetrics[saveMethod === 'create' ? 'createTrend' : 'updateTrend'](trend)
        .then(() => {
          onSaveSuccessCallback()
        })
        .catch(() => {
          onSaveFailCallback()
        })
    } else {
      onValidationErrorCallback(errors)
    }
  }

  delete (onDeleteSuccessCallback, onDeleteFailCallback, trendId) {
    return Api.DeviceMetrics.deleteTrend(trendId)
      .then(() => {
        onDeleteSuccessCallback()
      })
      .catch(async (error) => {
        if (error.status === 400) {
          const errorResponse = await error.json()
          onDeleteFailCallback(errorResponse?.base[0].name)
        } else {
          onDeleteFailCallback('Delete Failed')
        }
      })
  }

  validate (attributes) {
    const errors = {}
    if (!attributes.name) {
      errors['name'] = 'Name is required'
    }

    const filterMetricsList = attributes.metricList.filter((metric) => !metric.showInTooltip)

    if (filterMetricsList.length + attributes.groupList.length < 1) {
      errors['selectedList'] = 'Select at least one item from the list'
    } else if (!attributes.draft && _.some(_.map([...filterMetricsList, ...attributes.groupList], 'draft'))) {
      errors['selectedList'] = 'All metrics and groups of metrics must be published before a trend graph can be published'
    } else {
      if (_.unique([..._.pluck(filterMetricsList, 'unit'), ..._.pluck(attributes.groupList, 'unit')]).length > 3) {
        errors['selectedList'] = 'Max of 3 y-axis units allowed.'
      }
    }

    return errors
  }
}

export default TrendModel
